import { OfferStatus } from '@wwt/entities/api/search-response'

// TODO: Add trip completed
export const showDownloadVoucher: OfferStatus[] = [OfferStatus.RESERVED]
